module.exports = __webpack_public_path__ + "img/Dantam Hair 01.a3e3d17d.jpg";